import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { compose } from 'recompose'
import { renderRoutes } from 'react-router-config'
import { awardOverview as awardOverviewLayout } from 'constants/layout'

const enhance = compose(

)

class Awards extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    tabs: PropTypes.object,
    route: PropTypes.object
  }

  render() {
    const { tabs, children, route } = this.props

    return (
      <div>
        {tabs &&
          React.cloneElement(tabs, {
            links: awardOverviewLayout.tabs()
          })}
        {children}
        {renderRoutes(route.routes, this.props)}
      </div>
    )
  }
}

export default enhance(Awards)
